"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function MyFinance(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { height: "".concat(height), viewBox: "0 0 56 50", className: "".concat(className), width: "".concat(width) },
        React.createElement("path", { d: "M3.36759 0H51.973C53.8278 0 55.343 1.5152 55.343 3.36227V38.2539C55.343 40.0987 53.8278 41.6162 51.973 41.6162H3.36759C1.51517 41.6162 -2.36296e-05 40.0987 -2.36296e-05 38.2539V3.36227C-2.36296e-05 1.5152 1.51517 0 3.36759 0ZM4.21546 35.7808H51.1275V4.71621H4.21546V35.7808V35.7808Z", fill: "white" }),
        React.createElement("path", { d: "M33.907 43.2122L40.2671 49.6641H14.9835L21.3436 43.2122H33.907Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.3775 12.5401L41.142 12.0033C41.4877 11.9446 41.8074 12.2683 41.7508 12.6106L41.213 16.3685C41.1747 16.6361 40.9446 16.8293 40.681 16.8293C40.6558 16.8293 40.63 16.8275 40.6043 16.8238C40.3102 16.7819 40.1059 16.5101 40.1479 16.2165L40.4575 14.0531L36.3578 18.1456L36.3786 18.166L29.7071 24.7138C29.0334 25.3749 27.938 25.3736 27.2643 24.714L22.5588 20.0954C22.334 19.8753 21.9695 19.875 21.7446 20.0957L10.4666 31.1644C10.3542 31.2748 10.2068 31.33 10.0595 31.33C9.91216 31.33 9.76482 31.2747 9.65239 31.1644C9.42746 30.9437 9.42746 30.586 9.65239 30.3653L20.9303 19.2964C21.6046 18.6353 22.7 18.6366 23.3731 19.2961L28.0786 23.9147C28.3035 24.1349 28.6679 24.1352 28.8928 23.9144L35.5642 17.3669L35.5907 17.3929L39.6971 13.2938L37.5299 13.6028C37.2341 13.6445 36.9632 13.4405 36.9212 13.1475C36.8791 12.8539 37.0834 12.582 37.3775 12.5401Z", fill: "white" }),
        React.createElement("path", { d: "M43.5498 10.0325C41.0057 7.54157 36.8651 7.54157 34.321 10.0325C31.7774 12.524 31.7774 16.5776 34.321 19.0691C36.5866 21.2868 40.1151 21.5244 42.6575 19.7927C42.711 20.0405 42.8334 20.277 43.0303 20.4698L46.7353 24.0974C47.2752 24.625 48.1477 24.625 48.6849 24.0974C49.2242 23.5693 49.2242 22.7151 48.6849 22.1886L44.9799 18.5599C44.7841 18.3687 44.542 18.2483 44.2888 18.196C46.0586 15.7061 45.816 12.2518 43.5498 10.0325ZM42.3801 17.9238C40.4807 19.7835 37.3895 19.7835 35.4907 17.9238C33.5924 16.0641 33.5924 13.038 35.4907 11.1784C37.3895 9.31919 40.4807 9.31919 42.3801 11.1784C44.2795 13.038 44.2795 16.0641 42.3801 17.9238Z", fill: "white" })));
}
MyFinance.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
MyFinance.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = MyFinance;
